import { useEffect, useState } from 'react';

// True while the page is scrolling, false again `delay` ms after it stops.
function useScrollIdle(delay = 300) {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    let timer;
    const onScroll = () => {
      setScrolling(true);
      clearTimeout(timer);
      timer = setTimeout(() => setScrolling(false), delay);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timer);
    };
  }, [delay]);

  return scrolling;
}

export default useScrollIdle;
